import { render, staticRenderFns } from "./TroskovnikElement.vue?vue&type=template&id=f00b4666&"
import script from "./TroskovnikElement.vue?vue&type=script&lang=js&"
export * from "./TroskovnikElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports